<template>
    <div class="p-4">
        <redesign-pie-realtime-chart
            v-if="isRealtimeDataSource"
            :data="data"
            :font-size="labelFontSize"
            :labels-colors="dataLabelsColor"
        />
        <redesign-simple-pie-chart
            v-else
            :data="data"
            :font-size="labelFontSize"
            :labels-colors="dataLabelsColor"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import widgetDataSourceTypes from '@/enum/widgetDataSourceTypes'
import { WidgetExtended } from '@/types/dashboard'
import RedesignSimplePieChart from '@/components/RedesignComponents/Charts/RedesignSimplePieChart.vue'
import RedesignPieRealtimeChart from '@/components/RedesignComponents/Charts/RedesignPieRealtimeChart.vue'

const props = defineProps<{
    data: WidgetExtended
}>()

//Computed
const labelFontSize = computed(() => {
    return props.data?.WidgetLayout?.labelFontSize ?? 16
})
const dataLabelsColor = computed(() => {
    return props.data?.WidgetLayout?.dataLabelsColor ?? '#000000'
})
const isRealtimeDataSource = computed(() => {
    return props.data?.DataSourceTypeID === widgetDataSourceTypes.REAL_TIME_SOCKET
})
</script>

<style scoped lang="scss">

</style>

